import {
    collection,
    doc,
    query,
    serverTimestamp,
    setDoc,
    where,
} from "firebase/firestore";
import { nanoid } from "nanoid";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { Unit, UNIT_ATTACK_TYPE } from "../game/types/project";

const getDefaultUnit = () => {

};

type AllProjectReturn = {
    data: Unit[];
    status: "loading" | "error" | "success";
    addUnit: (callback: (id: string) => void) => void;
};

export default function useAllUnits({
    projectId,
}: {
    projectId: string;
}): AllProjectReturn {
    const DB = useFirestore();
    const COLLECTION = "units";

    const allUnits = collection(DB, COLLECTION);
    const allProjectUnits = query(allUnits, where("projectId", "==", projectId));

    const { status, data } = useFirestoreCollectionData(allProjectUnits);

    const addUnit = async (callback: (id: string) => void) => {
        const id = nanoid();
        const config: Unit = {
            id,
            lastUpdated: serverTimestamp(),
            name: "Default unit",
            projectId,
            texture: "",
            hp: 0,
            attack: 0,
            defense: 0,
            attackType: UNIT_ATTACK_TYPE.RANGED,
            weaknesses: [],
            resourcesCollectable: [],
            buildingsBuildable: [],
            type: "unit"
        };

        callback(id);

        await setDoc(doc(DB, COLLECTION, id), config);
    };

    return {
        data: (data || []) as Unit[],
        status,
        addUnit,
    };
}
